//import process from './process.json';
import settings from './config.json';

const config = function () {
   const env = process.env.NODE_ENV || 'development';
   return settings[env];
};

export default config();
